import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderFamilyRecipe from "../../../../src/content/grahamfamilyrecipesdigital/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderFamilyRecipe,
  React
};